
import { Injectable } from '@angular/core';
@Injectable()

export class ConfigLocal {  

 public ENDPOINT_API: string = 'WSprecheck/';

}